import * as url from "../url.helper";

import { post } from "../api.helper";

export const addCreditRating = data => post(url.ADD_CREDIT_RATING, data);

export const getCreditRating = data => post(url.GET_CREDIT_RATING, data);

export const editCreditRating = data => post(url.EDIT_CREDIT_RATING, data);

export const deleteCreditRating = data => post(url.DELETE_CREDIT_RATING, data);
